import GraphRepresentativeCmpx from "./graph-representative-cmpx";
export default GraphRepresentativeCmpx;
